<template>
  <transition name="slide-fade-delay">
    <section v-if="this.$store.state.selectedType == 4 || this.$store.state.edit_slots[5]"
             class="content-block small-padding"
    >
      <div class="slot block has-white-background">
        <div class="inner-block is-flex" id="sonnenaufgang_uhrzeit">
          <div class="col-2">
            <h1 class="title">{{ $t("general.label.tourSunrise") }}</h1>
            <h2 class="subtitle">{{ $t("fahrtView.label.tourSunriseHint") }}</h2>
          </div>
          <div class="col-2"/>
          <div class="line-element"/>
          <div v-if="this.$store.state.fetch_GET_Content_Sonnenaufgang && !this.$store.state.isLoading"
               class="slots is-flex"
          >
            <div
              class="slot col-6"
              v-for="(slot, i) in this.$store.state.fetch_GET_Content_Sonnenaufgang"
              :key="i"
              @click="selectSonnenaufgangSlotFn(slot)"
              :class="[
                  { active: slot.id == $store.state.sonnenaufgang_Slot_ID }, 
                  { dated: slot.isSlotExpired == true }, 
                  { low_capacity: getAvailableSlotCapacity(slot) < $store.state.ticket_reservation_amount }, 
                  { full: getAvailableSlotCapacity(slot) == 0 }, 
                  { booked: slot.id == $store.state.booking_sonnenaufgang_Slot_ID }
              ]"
            >
              <p>{{ getFormattedDate(slot.startTimestamp, 'dddd,') }}</p>
              <h2>{{ getFormattedDate(slot.startTimestamp, 'DD.MM.YYYY') }}</h2>
              <h2 class="time">{{ slot.startTimeFormatted }} {{ $t("general.label.clock") }}</h2>
              <p v-if="slot.isSlotExpired">{{ $t("fahrtView.label.slotExpired") }}</p>
              <p v-else-if="slot.id == $store.state.booking_sonnenaufgang_Slot_ID">{{
                  $t("fahrtView.label.slotBooked")
                }}</p>
              <p v-else-if="getAvailableSlotCapacity(slot) < $store.state.ticket_reservation_amount">
                {{
                  $t("fahrtView.label.slotCapacity", {
                    capacityLeft: getAvailableSlotCapacity(slot),
                    capacity: slot.capacity
                  })
                }}
              </p>
              <p v-else-if="getAvailableSlotCapacity(slot) == 0">{{ $t("fahrtView.label.slotSoldOut") }}</p>
              <p v-else :class="{ limited: check_capacityReservedFn(slot) }">
                {{
                  $t("fahrtView.label.slotCapacity", {
                    capacityLeft: getAvailableSlotCapacity(slot),
                    capacity: slot.capacity
                  })
                }}
              </p>
            </div>
            <div v-if="this.$store.state.fetch_GET_Content_Sonnenaufgang.length === 0">
              <p class="connection-note">
                <font-awesome-icon icon="info-circle"/>
                {{ $t("fahrtView.label.noSlotsFound") }}
              </p>
            </div>
          </div>
          <div v-else-if="this.$store.state.isLoading" class="loading-block">
            <div class="control is-small is-loading">
              <p class="connection-note loading">{{ $t("general.label.loadingContents") }}</p>
            </div>
          </div>
          <div v-else class="is-flex">
            <p class="connection-note">
              <font-awesome-icon icon="info-circle"/>
              {{ $t("general.label.noDataFound") }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>

import moment from 'moment'

export default {
  name: 'FahrtAuswahl',
  data() {
    return {
      active: false,
      dated: false
    }
  },
  mounted() {
    this.$store.show_Component_SonnenaufgangUhrzeit = true
  },
  destroyed() {
  },
  methods: {
    selectSonnenaufgangSlotFn(slot) {
      this.$store.state.sonnenaufgang_Slot_ID = slot.id;
      this.$store.state.sonnenaufgang_EventDate_ID = slot.eventDate.id;
      this.$store.state.sonnenaufgang_Slot_Time = slot.startTimeFormatted;
      this.$store.state.sonnenaufgang_Slot_Timestamp = this.getFormattedDate(slot.startTimestamp, 'DD.MM.YYYY');

      if (document.querySelector("#sonnenuntergang_uhrzeit")) {
        this.$scrollTo('#sonnenuntergang_uhrzeit', '2000')
      }
    },
    check_capacityReservedFn(slot) {
      let check_Sum = this.getAvailableSlotCapacity(slot);
      if (check_Sum <= 10) {
        return true
      }
    },
    getAvailableSlotCapacity(slot) {
      return slot.capacity - slot.capacityReserved - (slot.capacityInCart ? slot.capacityInCart : 0);
    },
    getFormattedDate(timestamp, format) {
      moment.locale(this.$t('general.settings.currentLanguageCode'));
      return moment.unix(timestamp).format(format);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.slots {
  width: 100%;
  position: relative;
  display: block;

  &.is-flex {
    flex-wrap: wrap;
  }

  .slot {
    width: 19.2%;
    height: auto;
    display: block;
    position: relative;
    margin-right: 1%;
    margin-top: 1%;
    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 2px;
    text-align: center;
    padding: 0.25rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:nth-child(5n) {
      margin-right: 0;
    }

    &.dated,
    &.low_capacity,
    &.full {
      background-color: rgba(200, 200, 200, 1);
      opacity: 0.4;
      pointer-events: none;

      p {
        color: #4a4a4a;
      }
    }

    p {
      font-size: 11px;
      margin-top: -1px;
      font-weight: 500;

      &:not(:first-of-type) {
        color: #6AB25C;
      }

      &.limited {
        color: #EB8C2D;
      }
    }

    &:hover {
      border: 1px solid rgba(150, 150, 150, 1);
      box-shadow: 0px 2px 6px rgba(35, 35, 35, 0.1);
    }

    &.booked {
      background-color: #004e9f;
      color: rgba(255, 255, 255, 0.8);
      border: 1px solid #004e9f;
      opacity: 0.5;

      p {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    &.active {
      background-color: #004e9f;
      color: rgba(255, 255, 255, 0.8);
      border: 1px solid #004e9f;

      p {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}

.line-element {
  width: 100%;
  height: 1px;
  background-color: rgb(200, 200, 200);
  margin-top: -0.55rem;
}

@media all and (min-width: 680px) and (max-width: 800px) {

}

@media (max-width: 680px) {
  .content-block {
    .slots .slot {
      width: 32%;
      margin-right: 2%;
      margin-top: 2%;

      &:nth-child(3n) {
        margin-right: 0 !important;
      }

      &:nth-child(7n) {
        margin-right: 2%;
      }
    }

    .block.slot {
      .subtitle {
        margin-bottom: 0.6em;
      }
    }
  }
}
</style>
